export function tooltip(label) {
    return `<div role="tooltip" id="priority-tooltip">${label}</div>`;
}
